import { config } from "@/http/config";
import { AppState, Auth0Provider } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

interface Props {
  children: React.ReactNode;
}

/**
 * Wraps the app in Auth0Provider using the Auth0 config from config.ts.
 */
export function Auth0ProviderWrapper({ children }: Props) {
  const navigate = useNavigate();
  const { auth0Domain, auth0ClientId, auth0Audience } = config();

  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo ?? window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      useRefreshTokens={true}
      useRefreshTokensFallback={false}
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: auth0Audience,
        scope: "openid profile email offline_access",
      }}
    >
      {children}
    </Auth0Provider>
  );
}
